import { useContext } from 'react';
import { SidebarManagerContext } from '@/common/components/sidebar-manager/SidebarManagerContext.ts';

export function useSidebarManager() {
  return useContext(SidebarManagerContext);
}
